import { render, staticRenderFns } from "./SiteHeaderMenu.vue?vue&type=template&id=397bf0a2&lang=pug&"
import script from "./SiteHeaderMenu.vue?vue&type=script&lang=js&"
export * from "./SiteHeaderMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports